import { alias, empty } from '@ember/object/computed';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['attachment-list-container'],
  classNameBindings: ['hasNoAttachments:composer-is-hidden'],
  attachmentList: alias('composerState.attachmentList.content'),
  hasNoAttachments: empty('attachmentList')
});